import { trackAnalyticsEvent } from '../track'

interface DeprecatedVaultPromptParams {
  chainId: number
  vaultAddress: string
}

export type DeprecatedVaultPromptVariant = 'card' | 'chip'

export function trackDeprecatedVaultPromptViewed({
  chainId,
  vaultAddress,
  variant
}: DeprecatedVaultPromptParams & { variant: DeprecatedVaultPromptVariant }) {
  trackAnalyticsEvent('deprecated_vault_prompt_viewed', {
    chain_id: chainId,
    vault_address: vaultAddress,
    variant
  })
}

export function trackDeprecatedVaultPromptToggled({
  chainId,
  vaultAddress,
  isExpanded
}: DeprecatedVaultPromptParams & { isExpanded: boolean }) {
  trackAnalyticsEvent('deprecated_vault_prompt_toggled', {
    chain_id: chainId,
    vault_address: vaultAddress,
    is_expanded: isExpanded
  })
}

export function trackDeprecatedVaultPromptClicked({
  chainId,
  vaultAddress
}: DeprecatedVaultPromptParams) {
  trackAnalyticsEvent('deprecated_vault_prompt_clicked', {
    chain_id: chainId,
    vault_address: vaultAddress
  })
}
